import { render, staticRenderFns } from "./startEnd.vue?vue&type=template&id=1522ae66"
import script from "./startEnd.vue?vue&type=script&lang=js"
export * from "./startEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1522ae66')) {
      api.createRecord('1522ae66', component.options)
    } else {
      api.reload('1522ae66', component.options)
    }
    module.hot.accept("./startEnd.vue?vue&type=template&id=1522ae66", function () {
      api.rerender('1522ae66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flowable/nodePanel/startEnd.vue"
export default component.exports